<svg
  width="990px"
  height="69px"
  viewBox="0 0 990 69"
  version="1.1"
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
>
  <title>Green</title>
  <g id="2-Mon-paiement,-mes-frais" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
    <g id="Desktop-animation-nuages" transform="translate(-337.000000, -2283.000000)" stroke-width="1.5">
      <g id="Group-4-Copy-5" transform="translate(189.000000, 2168.000000)">
        <g id="info" transform="translate(6.000000, 76.081465)">
          <g id="landscape-01" transform="translate(0.000000, 0.918535)">
            <g id="Green" transform="translate(143.000000, 40.000000)">
              <g id="tree-5" transform="translate(526.811321, 27.70000)">
                <g class="animated-tree delay-4" stroke="#00874E" stroke-width="1.5">
                  <path
                    transform="translate(-1, -13)"
                    d="M10.5,0.9 C14.7,0.9 18.1,4.3 18.1,8.5 C18.1,10.5 17.4,12.2 16.1,13.6 C19,15.5 21,18.7 21,22.5 C21,28.3 16.3,33 10.5,33 C4.7,33 0,28.2 0,22.4 C0,18.7 1.9,15.4 4.9,13.5 C3.7,12.2 2.9,10.4 2.9,8.4 C2.9,4.3 6.3,0.9 10.5,0.9 Z"
                    fill="#DCF8E0"
                  ></path>
                  <path
                    class="animated-tree-trunk delay-4"
                    d="M10.1,6 C10.0497304,11.0280977 10.016397,16.0180977 10,20.97 C9.98360297,25.9219023 9.98360297,30.9985689 10,36.2"
                  ></path>
                  <line x1="10.1" y1="14.9" x2="5.1" y2="8.5"></line>
                </g>
              </g>

              <g *ngIf="isIndicateurRisqueMoyenHaut" id="Grande_maison" transform="translate(339.000000, 0.000000)">
                <g id="grande_maison-copy" transform="translate(20.000000, 0.000000)" stroke="#666666">
                  <polygon
                    id="maison-risque-haut-desktop"
                    points="118.1 0.1 118.1 24.7 161.6 24.7 161.6 64.1 7 64.1 7 25.7 54.1 25.7 54.1 0.1"
                  ></polygon>
                  <polyline id="path_0_desktop" points="118.1 24.7 118.1 0.1 54.1 0.1 54.1 63.7"></polyline>
                  <polygon id="path_1_desktop" fill="#E6E6E6" points="60.6 19.4 111.7 19.4 111.7 9 60.6 9"></polygon>
                  <polygon
                    id="path_2_desktop"
                    fill="#E6E6E6"
                    points="60.6 52.8 71.8 52.8 71.8 24.7 60.6 24.7"
                  ></polygon>
                  <polygon
                    id="path_3_desktop"
                    fill="#E6E6E6"
                    points="144.7 56 153.5 56 153.5 35.1 144.7 35.1"
                  ></polygon>
                  <polygon id="path_4_desktop" fill="#E6E6E6" points="118.1 56 127 56 127 35.1 118.1 35.1"></polygon>
                  <polygon
                    id="path_5_desktop"
                    fill="#E6E6E6"
                    points="131.8 56 140.7 56 140.7 35.1 131.8 35.1"
                  ></polygon>
                  <polyline id="path_6_desktop" points="89.1 63.7 89.1 24.7 161.6 24.7 161.6 63.4"></polyline>
                  <polyline id="path_7_desktop" points="7 64.1 7 25.7 53.7 25.7"></polyline>
                  <g id="Group-1" transform="translate(14.000000, 35.000000)" fill="#666666">
                    <polyline id="path_8_desktop" points="0.1 29.1 0.1 0.1 33.1 0.1 33.1 28.9"></polyline>
                  </g>
                  <g id="Group-2" transform="translate(99.000000, 35.000000)">
                    <polygon id="path_9_desktop" fill="#E6E6E6" points="0.2 7.4 9.9 7.4 9.9 0.9 0.2 0.9"></polygon>
                    <polyline id="path_10_desktop" fill="#666666" points="0.2 29.1 0.2 7.8 9.9 7.8 9.9 29.1"></polyline>
                  </g>
                </g>
              </g>

              <g
                *ngIf="!isIndicateurRisqueMoyenHaut"
                id="petite_maison-desktop"
                transform="translate(344.000000, 0.081465)"
              >
                <g id="Group-7" transform="translate(0.951807, 0.000000)">
                  <g id="small" transform="translate(63.048193, 0.000000)">
                    <polygon
                      id="Combined-Shape"
                      fill="#FFFFFF"
                      fill-rule="nonzero"
                      points="2.3 63.2 2.3 1 64.2 0.8 64.2 25.7 95.3 25.7 95.3 63.1"
                    ></polygon>
                    <g id="maison_05" transform="translate(0.000000, 1.000000)" stroke="#666666" stroke-width="1.5">
                      <polygon id="Path" fill="#E6E6E6" points="8.7 19.6 58.1 19.6 58.1 9.6 8.7 9.6"></polygon>
                      <line x1="2.3" y1="4.7" x2="2.3" y2="63" id="Line-3" stroke-linecap="square"></line>
                      <line x1="64" y1="4.7" x2="64" y2="25.3" id="Line-3-Copy" stroke-linecap="square"></line>
                      <line x1="95.3" y1="29.9" x2="95.3" y2="63" id="Path_1_"></line>
                      <rect id="Rectangle" fill="#E6E6E6" x="32" y="25.3" width="65.9" height="4.6"></rect>
                      <rect id="Rectangle_1_" fill="#E6E6E6" x="0.1" y="0" width="65.9" height="4.6"></rect>
                      <polygon id="Path_2_" fill="#E6E6E6" points="8.7 52.4 19.7 52.4 19.7 23 8.7 23"></polygon>
                      <polygon id="Path_3_" fill="#E6E6E6" points="64.6 55 73.3 55 73.3 35.2 64.6 35.2"></polygon>
                      <polygon id="Path_4_" fill="#E6E6E6" points="46.2 41.5 55.8 41.5 55.8 35.2 46.2 35.2"></polygon>
                      <polygon id="Path_5_" fill="#E6E6E6" points="77.9 55 86.6 55 86.6 35.2 77.9 35.2"></polygon>
                      <polyline id="Stroke-11" fill="#666666" points="46.2 63 46.2 41.5 55.8 41.5 55.8 63"></polyline>
                      <line x1="35.5" y1="29.9" x2="35.5" y2="63" id="Stroke-13"></line>
                    </g>
                  </g>
                  <path
                    d="M178.3,54.7 C179.4,53.3 181.1,52.4 183.1,52.4 C185.4,52.4 187.4,53.6 188.4,55.5 C188.7,55.3 189.1,55.2 189.5,55.2 C190.5,55.2 191.2,55.9 191.2,56.9 C191.2,57 191.2,57.1 191.2,57.2 C192.8,57.5 194.1,58.9 194.1,60.5 C194.1,62.4 192.5,64.1 190.6,64.1 L171,64.1 C168,64.1 165.5,62.9 165.5,61.3 L165.5,61.2 C165.5,61.1 165.5,61.1 165.5,61 C165.5,60.1 166.1,59.3 167.1,59 L167.7,58.8 L167.7,58.1 C167.7,55 170.4,52.5 173.6,52.5 C175.5,52.5 177.2,53.3 178.3,54.7 Z"
                    id="bushes-right"
                    stroke="#00874E"
                    stroke-width="1.5"
                    fill="#DCF8E0"
                  ></path>
                </g>
              </g>

              <g id="tree-1" transform="translate(32.000000, 27.700000)">
                <g class="animated-tree" stroke="#00874E" stroke-width="1.5">
                  <path
                    d="M20,10.5 C20,16.3 15.5,21 10,21 C4.5,21 0,16.3 0,10.5 C0,4.7 4.5,0 10,0 C15.5,0 20,4.7 20,10.5 Z"
                    fill="#DCF8E0"
                  ></path>
                  <path
                    class="animated-tree-trunk"
                    d="M10.1,6 C10.0497304,11.0280977 10.016397,16.0180977 10,20.97 C9.98360297,25.9219023 9.98360297,30.9985689 10,36.2"
                  ></path>
                  <line x1="10.1" y1="14.9" x2="5.1" y2="8.5"></line>
                </g>
              </g>

              <g id="tree-2" transform="translate(226.000000, 27.70000)">
                <g class="animated-tree delay-1" stroke="#00874E" stroke-width="1.5">
                  <path
                    transform="translate(-1, -13)"
                    d="M10.5,0.9 C14.7,0.9 18.1,4.3 18.1,8.5 C18.1,10.5 17.4,12.2 16.1,13.6 C19,15.5 21,18.7 21,22.5 C21,28.3 16.3,33 10.5,33 C4.7,33 0,28.2 0,22.4 C0,18.7 1.9,15.4 4.9,13.5 C3.7,12.2 2.9,10.4 2.9,8.4 C2.9,4.3 6.3,0.9 10.5,0.9 Z"
                    fill="#DCF8E0"
                  ></path>
                  <path
                    class="animated-tree-trunk delay-1"
                    d="M10.1,6 C10.0497304,11.0280977 10.016397,16.0180977 10,20.97 C9.98360297,25.9219023 9.98360297,30.9985689 10,36.2"
                  ></path>
                  <line x1="10.1" y1="14.9" x2="5.1" y2="8.5"></line>
                </g>
              </g>

              <g transform="translate(252.500000, 27.70000)">
                <g class="animated-tree delay-2" stroke="#00874E" stroke-width="1.5">
                  <path
                    transform="translate(-2, -27)"
                    d="M24,24.9 C24,38.2 18.6,48.9 12,48.9 C5.4,48.9 0,38.2 0,24.9 C0,11.6 5.4,0.9 12,0.9 C18.6,0.9 24,11.6 24,24.9 Z"
                    fill="#DCF8E0"
                  ></path>
                  <path
                    class="animated-tree-trunk delay-2"
                    d="M10.1,6 C10.0497304,11.0280977 10.016397,16.0180977 10,20.97 C9.98360297,25.9219023 9.98360297,30.9985689 10,36.2"
                  ></path>
                  <line x1="10.1" y1="14.9" x2="5.1" y2="8.5"></line>
                </g>
              </g>

              <g *ngIf="isIndicateurRisqueMoyenHaut" id="tree-4" transform="translate(339.000000, 28.433962)">
                <g class="animated-tree delay-3" stroke="#00874E" stroke-width="1.5">
                  <path
                    d="M20,10.5 C20,16.3 15.5,21 10,21 C4.5,21 0,16.3 0,10.5 C0,4.7 4.5,0 10,0 C15.5,0 20,4.7 20,10.5 Z"
                    fill="#DCF8E0"
                  ></path>
                  <path
                    class="animated-tree-trunk delay-3"
                    d="M10.1,6 C10.0497304,11.0280977 10.016397,16.0180977 10,20.97 C9.98360297,25.9219023 9.98360297,30.9985689 10,36.2"
                  ></path>
                  <line x1="10.1" y1="14.9" x2="5.1" y2="8.5"></line>
                </g>
              </g>

              <g *ngIf="!isIndicateurRisqueMoyenHaut" id="tree-4-alt" transform="translate(339.000000, 27.70000)">
                <g class="animated-tree delay-3" stroke="#00874E" stroke-width="1.5">
                  <path
                    transform="translate(-2, -27)"
                    d="M24,24.9 C24,38.2 18.6,48.9 12,48.9 C5.4,48.9 0,38.2 0,24.9 C0,11.6 5.4,0.9 12,0.9 C18.6,0.9 24,11.6 24,24.9 Z"
                    fill="#DCF8E0"
                  ></path>
                  <path
                    class="animated-tree-trunk delay-3"
                    d="M10.1,6 C10.0497304,11.0280977 10.016397,16.0180977 10,20.97 C9.98360297,25.9219023 9.98360297,30.9985689 10,36.2"
                  ></path>
                  <line x1="10.1" y1="14.9" x2="5.1" y2="8.5"></line>
                </g>
              </g>

              <g *ngIf="isIndicateurRisqueMoyenHaut" id="tree-6" transform="translate(552.603774, 27.70000)">
                <g class="animated-tree delay-5" stroke="#00874E" stroke-width="1.5">
                  <path
                    transform="translate(-2, -27)"
                    d="M24,24.9 C24,38.2 18.6,48.9 12,48.9 C5.4,48.9 0,38.2 0,24.9 C0,11.6 5.4,0.9 12,0.9 C18.6,0.9 24,11.6 24,24.9 Z"
                    fill="#DCF8E0"
                  ></path>
                  <path
                    class="animated-tree-trunk delay-5"
                    d="M10.1,6 C10.0497304,11.0280977 10.016397,16.0180977 10,20.97 C9.98360297,25.9219023 9.98360297,30.9985689 10,36.2"
                  ></path>
                  <line x1="10.1" y1="14.9" x2="5.1" y2="8.5"></line>
                </g>
              </g>

              <g id="tree-7" transform="translate(864, 27.70000)">
                <g class="animated-tree delay-6" stroke="#00874E" stroke-width="1.5">
                  <path
                    transform="translate(-1, -13)"
                    d="M10.5,0.9 C14.7,0.9 18.1,4.3 18.1,8.5 C18.1,10.5 17.4,12.2 16.1,13.6 C19,15.5 21,18.7 21,22.5 C21,28.3 16.3,33 10.5,33 C4.7,33 0,28.2 0,22.4 C0,18.7 1.9,15.4 4.9,13.5 C3.7,12.2 2.9,10.4 2.9,8.4 C2.9,4.3 6.3,0.9 10.5,0.9 Z"
                    fill="#DCF8E0"
                  ></path>
                  <path
                    class="animated-tree-trunk delay-6"
                    d="M10.1,6 C10.0497304,11.0280977 10.016397,16.0180977 10,20.97 C9.98360297,25.9219023 9.98360297,30.9985689 10,36.2"
                  ></path>
                  <line x1="10.1" y1="14.9" x2="5.1" y2="8.5"></line>
                </g>
              </g>

              <g id="tree-8" transform="translate(890.500000, 27.70000)">
                <g class="animated-tree delay-7" stroke="#00874E" stroke-width="1.5">
                  <path
                    transform="translate(-2, -27)"
                    d="M24,24.9 C24,38.2 18.6,48.9 12,48.9 C5.4,48.9 0,38.2 0,24.9 C0,11.6 5.4,0.9 12,0.9 C18.6,0.9 24,11.6 24,24.9 Z"
                    fill="#DCF8E0"
                  ></path>
                  <path
                    class="animated-tree-trunk delay-7"
                    d="M10.1,6 C10.0497304,11.0280977 10.016397,16.0180977 10,20.97 C9.98360297,25.9219023 9.98360297,30.9985689 10,36.2"
                  ></path>
                  <line x1="10.1" y1="14.9" x2="5.1" y2="8.5"></line>
                </g>
              </g>

              <g id="tree-9" transform="translate(955, 27.70000)">
                <g class="animated-tree delay-8" stroke="#00874E" stroke-width="1.5">
                  <path
                    transform="translate(-1, -13)"
                    d="M10.5,0.9 C14.7,0.9 18.1,4.3 18.1,8.5 C18.1,10.5 17.4,12.2 16.1,13.6 C19,15.5 21,18.7 21,22.5 C21,28.3 16.3,33 10.5,33 C4.7,33 0,28.2 0,22.4 C0,18.7 1.9,15.4 4.9,13.5 C3.7,12.2 2.9,10.4 2.9,8.4 C2.9,4.3 6.3,0.9 10.5,0.9 Z"
                    fill="#DCF8E0"
                  ></path>
                  <path
                    class="animated-tree-trunk delay-8"
                    d="M10.1,6 C10.0497304,11.0280977 10.016397,16.0180977 10,20.97 C9.98360297,25.9219023 9.98360297,30.9985689 10,36.2"
                  ></path>
                  <line x1="10.1" y1="14.9" x2="5.1" y2="8.5"></line>
                </g>
              </g>

              <path
                d="M12.8,54.8 C13.9,53.4 15.6,52.5 17.6,52.5 C19.9,52.5 21.9,53.7 22.9,55.6 C23.2,55.4 23.6,55.3 24,55.3 C25,55.3 25.7,56 25.7,57 C25.7,57.1 25.7,57.2 25.7,57.3 C27.3,57.6 28.6,59 28.6,60.6 C28.6,62.5 27,64.2 25.1,64.2 L5.5,64.2 C2.5,64.2 2.84217094e-14,63 2.84217094e-14,61.4 L2.84217094e-14,61.3 C2.84217094e-14,61.2 2.84217094e-14,61.2 2.84217094e-14,61.1 C2.84217094e-14,60.2 0.6,59.4 1.6,59.1 L2.2,58.9 L2.2,58.2 C2.2,55.1 4.9,52.6 8.1,52.6 C10,52.5 11.7,53.4 12.8,54.8 Z"
                id="bushes-left"
                stroke="#00874E"
                fill="#DCF8E0"
              ></path>
              <path
                d="M286.8,54.8 C287.9,53.4 289.6,52.5 291.6,52.5 C293.9,52.5 295.9,53.7 296.9,55.6 C297.2,55.4 297.6,55.3 298,55.3 C299,55.3 299.7,56 299.7,57 C299.7,57.1 299.7,57.2 299.7,57.3 C301.3,57.6 302.6,59 302.6,60.6 C302.6,62.5 301,64.2 299.1,64.2 L279.5,64.2 C276.5,64.2 274,63 274,61.4 L274,61.3 C274,61.2 274,61.2 274,61.1 C274,60.2 274.6,59.4 275.6,59.1 L276.2,58.9 L276.2,58.2 C276.2,55.1 278.9,52.6 282.1,52.6 C284,52.5 285.7,53.4 286.8,54.8 Z"
                id="bushes-middle"
                stroke="#00874E"
                fill="#DCF8E0"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </g>
  </g>
</svg>
